// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"edea627e","703":"8b0bf5dc","787":"4aba8310"}[chunkId] + ".chunk.js";
};